"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Sort = exports.DESCENDING = exports.ASCENDING = void 0;
var _react = _interopRequireDefault(require("react"));
var _sortAscending = _interopRequireDefault(require("../../../../assets/sortAscending.svg"));
var _sortDescending = _interopRequireDefault(require("../../../../assets/sortDescending.svg"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var ASCENDING = exports.ASCENDING = "ascending";
var DESCENDING = exports.DESCENDING = "descending";
var Sort = exports.Sort = function Sort(_ref) {
  var selectedButton = _ref.selectedButton,
    handleSortClick = _ref.handleSortClick;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "selection_container ascDesc_filter"
  }, /*#__PURE__*/_react["default"].createElement("button", {
    className: "sort_btn descending",
    style: {
      color: selectedButton === DESCENDING ? "green" : "black",
      border: selectedButton === DESCENDING ? "1px solid green" : "",
      backgroundColor: selectedButton === DESCENDING ? "#F2F7E9" : "transparent"
    },
    onClick: function onClick() {
      handleSortClick(selectedButton === DESCENDING ? "" : DESCENDING);
    }
  }, /*#__PURE__*/_react["default"].createElement("img", {
    src: _sortDescending["default"],
    alt: "Descending Icon",
    style: {
      filter: selectedButton === DESCENDING ? "invert(34%) sepia(95%) saturate(749%) hue-rotate(82deg)" : ""
    }
  }), /*#__PURE__*/_react["default"].createElement("p", null, "Descending")), /*#__PURE__*/_react["default"].createElement("button", {
    className: "sort_btn ascending",
    style: {
      color: selectedButton === ASCENDING ? "green" : "black",
      border: selectedButton === ASCENDING ? "1px solid green" : "",
      backgroundColor: selectedButton === ASCENDING ? "#F2F7E9" : "transparent"
    },
    onClick: function onClick() {
      handleSortClick(selectedButton === ASCENDING ? "" : ASCENDING);
    }
  }, /*#__PURE__*/_react["default"].createElement("img", {
    src: _sortAscending["default"],
    alt: "Ascending Icon",
    style: {
      filter: selectedButton === ASCENDING ? "invert(34%) sepia(95%) saturate(749%) hue-rotate(82deg)" : ""
    }
  }), /*#__PURE__*/_react["default"].createElement("p", null, "Ascending")));
};